import * as React from "react";

export const FileSVG = (props: any) => (
    <svg id="uploadDocIcon" xmlns="http://www.w3.org/2000/svg" width="35.997" height="37.798" viewBox="0 0 35.997 37.798">
        <defs>
            <filter id="Path_3304" x="4.512" y="2.5" width="29.485" height="33.298" filterUnits="userSpaceOnUse">
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="1.5" result="blur" />
                <feFlood floodOpacity="0.161" />
                <feComposite operator="in" in2="blur" />
                <feComposite in="SourceGraphic" />
            </filter>
        </defs>
        <circle id="Ellipse_180" data-name="Ellipse 180" cx="16" cy="16" r="16" fill="#ced4da" />
        <g id="Group_4617" data-name="Group 4617" transform="translate(4.378 2.337)">
            <g transform="matrix(1, 0, 0, 1, -4.38, -2.34)" filter="url(#Path_3304)">
                <path id="Path_3304-2" data-name="Path 3304" d="M0,0H18.375l4.11,3.758V26.3H0Z" transform="translate(5.01 3)" fill="#fff" />
            </g>
            <path
                id="Path_3305"
                data-name="Path 3305"
                d="M-1544.552-19548.811l3.993,3.734-.739.258-2.071.145s-.707-.469-.74-.518-.542-1-.558-1.092S-1544.552-19548.811-1544.552-19548.811Z"
                transform="translate(1563.442 19549.584)"
                fill="#ced4da"
            />
            <path
                id="Path_3295"
                data-name="Path 3295"
                d="M69.621,84.392H67.1a2.011,2.011,0,0,1-2.03-1.988V80H48.133a.309.309,0,0,0-.312.306v24.909a.309.309,0,0,0,.312.306H69.309a.309.309,0,0,0,.312-.306Zm-.643-.917-2.973-2.911V82.4a1.083,1.083,0,0,0,1.093,1.07ZM50.289,106.438H48.133a1.238,1.238,0,0,1-1.249-1.223V80.3a1.238,1.238,0,0,1,1.249-1.223h17.1a1.44,1.44,0,0,1,.19.014.47.47,0,0,1,.466.145,1.4,1.4,0,0,1,.338.245l3.918,3.837a1.353,1.353,0,0,1,.412.973v20.919a1.238,1.238,0,0,1-1.249,1.223H50.289Z"
                transform="translate(-46.884 -79.082)"
            />
            <path
                id="Path_3296"
                data-name="Path 3296"
                d="M164.735,165.18H153.706a.459.459,0,1,0,0,.917h11.029a.459.459,0,1,0,0-.917Zm0,0"
                transform="translate(-144.934 -157.222)"
            />
            <path
                id="Path_3297"
                data-name="Path 3297"
                d="M164.735,219.895H153.706a.459.459,0,1,0,0,.917h11.029a.459.459,0,1,0,0-.917Zm0,0"
                transform="translate(-144.934 -207.754)"
            />
            <path
                id="Path_3298"
                data-name="Path 3298"
                d="M164.735,274.6H153.706a.459.459,0,1,0,0,.917h11.029a.459.459,0,1,0,0-.917Zm0,0"
                transform="translate(-144.934 -258.281)"
            />
            <path
                id="Path_3299"
                data-name="Path 3299"
                d="M164.735,329.32H153.706a.459.459,0,1,0,0,.917h11.029a.459.459,0,1,0,0-.917Zm0,0"
                transform="translate(-144.934 -308.813)"
            />
            <path
                id="Path_3300"
                data-name="Path 3300"
                d="M91.749,155.18A1.223,1.223,0,1,0,93,156.4,1.236,1.236,0,0,0,91.749,155.18Zm0,1.529a.306.306,0,1,1,.312-.306A.309.309,0,0,1,91.749,156.709Zm0,0"
                transform="translate(-87.095 -147.986)"
            />
            <path
                id="Path_3301"
                data-name="Path 3301"
                d="M91.749,209.9A1.223,1.223,0,1,0,93,211.118,1.236,1.236,0,0,0,91.749,209.9Zm0,1.529a.306.306,0,1,1,.312-.306A.309.309,0,0,1,91.749,211.424Zm0,0"
                transform="translate(-87.095 -198.518)"
            />
            <path
                id="Path_3302"
                data-name="Path 3302"
                d="M91.749,264.605A1.223,1.223,0,1,0,93,265.828,1.236,1.236,0,0,0,91.749,264.605Zm0,1.529a.306.306,0,1,1,.312-.306A.309.309,0,0,1,91.749,266.134Zm0,0"
                transform="translate(-87.095 -249.046)"
            />
            <path
                id="Path_3303"
                data-name="Path 3303"
                d="M91.749,319.32A1.223,1.223,0,1,0,93,320.543,1.236,1.236,0,0,0,91.749,319.32Zm0,1.529a.306.306,0,1,1,.312-.306A.309.309,0,0,1,91.749,320.849Zm0,0"
                transform="translate(-87.095 -299.578)"
            />
        </g>
    </svg>
);
